module.exports = __webpack_public_path__ + "img/MGH-Gaien-10.9283d3fe.jpg";